import React, { memo } from "react";

import Icon from "app/components/Icon/Icon";
import { ReactComponent } from "./svgs/negative_test_flows.svg";

export const NegativeTestFlowsIcon = memo(() => {
  return <Icon component={ReactComponent} />;
});
